
import React, {FC, useEffect} from 'react';
import classNames from 'classnames';
import {ChatArea} from 'components/Assistant/ChatArea';
import {Assistant} from 'components/Assistant/hooks/types';
import {ChatSubmit} from 'components/Inputs/ChatSubmit';

import {InitMessage, renderer} from './renderer';

import * as styles from './styles.module.scss';

type AssistantProps = {
	className?: string
	assistant: Assistant
	track?: string
}

export const Chat: FC<AssistantProps> = ({
	className,
	assistant,
	track,
}) => {
	useEffect(() => {
		assistant.send(InitMessage);
	}, []);
	return (
		<div className={classNames(styles.chat, className)}>
			<div className={styles.scroll}>
				<ChatArea
					className={styles.area}
					pending={{variant: 'white'}}
					state={assistant.state}
					send={assistant.send}
					track={track}
					renderer={renderer}
				/>
			</div>
			<ChatSubmit onSubmit={assistant.send}>
				Type your question here
			</ChatSubmit>
		</div>
	);
};
